
export const CLICK_SEARCH_POLYGONS_BY_SERVICEID = 'CLICK_SEARCH_POLYGONS_BY_SERVICEID';

export function clickSearchPolygonsByServiceId(cityId, serviceId) {
    return {
        type: CLICK_SEARCH_POLYGONS_BY_SERVICEID,
        serviceId,
        cityId
    }
}